<script lang="ts">
  import { Moon, Sun } from "@lucide/svelte";
  import { MODES, SKINS, type Mode, type Skin } from "../model";

  let { mode, skin, onModeChange, onSkinChange }: {
    mode: Mode; skin: Skin; onModeChange?: (mode: Mode) => void; onSkinChange?: (skin: Skin) => void;
  } = $props();
</script>

<div class="appearance-controls">
  <button class="mode-toggle" type="button" aria-label={`Switch to ${mode === "dark" ? "light" : "dark"} mode`} onclick={() => onModeChange?.(mode === "dark" ? "light" : "dark")} style={`--toggle:${MODES[mode].toggle};--accent:${SKINS[skin].accent}`}>
    <span class:light={mode === "light"} class="mode-thumb"></span>
    <span class="mode-icon sun"><Sun size={14} strokeWidth={2.4} color={mode === "light" ? MODES[mode].bg : MODES[mode].muted} /></span>
    <span class="mode-icon moon"><Moon size={14} strokeWidth={2.4} color={mode === "dark" ? MODES[mode].bg : MODES[mode].muted} /></span>
  </button>

  <div class="skin-selector" role="radiogroup" aria-label="Color skin">
    {#each Object.keys(SKINS) as key (key)}
      <button class:active={skin === key} class="skin-dot" type="button" role="radio" aria-checked={skin === key} aria-label={`${key} skin`} title={`${key} skin`} style={`--dot:${SKINS[key as Skin].dot};--surface:${MODES[mode].surface}`} onclick={() => onSkinChange?.(key as Skin)}></button>
    {/each}
  </div>
</div>
